import { OverlayProperties } from './interfaces';

export const defaultProperties: OverlayProperties = {
  animationDuration: 100,
  animationTimingFunction: 'ease-in-out',
  position: 'absolute',
  zIndex: 1000,
  fadeIn: true,
};
